<div class="input-group search-input-group">
  <!-- <div class="input-group-prepend select-style">
   <button class="btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">{{ currentSearchItem.itemValue | translate }}</button>
    <div class="dropdown-menu">
      <a class="btn btn-sm btn-block dropdown-item" (click)="onSearchChange(item)" *ngFor="let item of dropdownItems">{{ item.itemValue | translate }}</a>
    </div>
  </div> -->
  <div class="search-type-selection input-group-prepend select-style">
    <button class="btn btn-sm" type="button" aria-haspopup="true" (focusin)="focusIn()"
            aria-expanded="false">{{ currentSearchItem.itemValue | translate }}</button>
  </div>
  
  <div class="country-selection input-group-prepend select-style" *ngIf="currentSearchItem.itemKey === 'customer'">
    <button (click)="toggleData();" (focusout)="onClickOutside($event)" class="btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" 
            aria-expanded="false">{{currentInnerSearchItem.itemValue}}</button> 
         
    <div class="dropdown-menu">
      <a class="btn btn-sm btn-block dropdown-item dropdown-list" (click)="onInnerSearchChange(item)" *ngFor="let item of (dropdownItems[0].innerSearch)">
        {{ item.itemValue }}</a>
    </div>
  </div>
  <input type="text" class="form-control select-style" [autofocus]="currentSearchItem.focus" [placeholder]="currentSearchItem.placeHolder | translate" [(ngModel)]="searchTextValue"
         (keyup.enter)="onSearchValueChange();" (keydown.Tab)="onSearchValueChange();" (focusin)="focusIn()" aria-label="Text input with dropdown button">
  <!-- <div class="dropdown-button select-style">
    <input type="text" class="form-control" [autofocus]="currentSearchItem.focus" [placeholder]="currentSearchItem.placeHolder | translate" [(ngModel)]="searchTextValue"
           (keyup.enter)="onSearchValueChange()" aria-label="Text input with dropdown button">
  </div> -->
</div>
